/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { entityState } from "./entity.state";
import { createEntity, fetchEntity, saveEntity } from "./entity.thunks";
import { Logger } from "cms/utils/log/logger";

const entity = createSlice({
    
    name: "entity",

    initialState: entityState,

    reducers: {
        setCurrentEntity (state, action) {
            const entity = action?.payload;
            state.current = entity;
        },

        removeCurrentEntity (state) {
            state.current = {};
        },

        setEntitySchemas (state, action) {
            const schemas = action?.payload;
            state.schemas = schemas;
        },

        setLoading (state, action) {
            state.loading = action?.payload;
        },
    },

    extraReducers (builder) {

        // save entity
        builder.addCase(saveEntity.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(saveEntity.fulfilled, (state, action) => {
            state.current = action.payload;
            state.loading = false;
        });

        builder.addCase(saveEntity.rejected, (state, action) => {
            // todo: properly record errors
            Logger.error("updateModel has an error: ", action.error);
            state.loading = false;
        });


        // create entity
        builder.addCase(createEntity.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(createEntity.fulfilled, (state, action) => {
            state.current = action.payload;
            state.loading = false;
        });

        builder.addCase(createEntity.rejected, (state, action) => {
            // todo: properly record errors
            Logger.error("createModel has an error: ", action.error);
            state.loading = false;
        });


        // fetch entity
        builder.addCase(fetchEntity.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(fetchEntity.fulfilled, (state, action) => {
            const entity = action.payload;
            state.current = entity;
            state.loading = false;
        });

        builder.addCase(fetchEntity.rejected, (state, action) => {
            // todo: properly record errors
            Logger.error("fetchModel has an error: ", action.error);
            state.loading = false;
        });
    }
});

export const entityReducer = entity.reducer;

export const {
    setCurrentEntity,
    removeCurrentEntity,
    setEntitySchemas,
} = entity.actions;

